"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var useBreakpoints_hook_exports = {};
__export(useBreakpoints_hook_exports, {
  Breakpoint: () => Breakpoint,
  useBreakpoints: () => useBreakpoints
});
module.exports = __toCommonJS(useBreakpoints_hook_exports);
var import_useMediaQuery = require("../useMediaQuery/useMediaQuery.hook");
var useBreakpoints = function useBreakpoints2() {
  var breakpoints = {
    isXs: (0, import_useMediaQuery.useMediaQuery)("(max-width: 319px)"),
    // For 400% Zoom, the “small” layout size applies for viewports/breakpoints for screen width of 320px to 679px.
    isSm: (0, import_useMediaQuery.useMediaQuery)("(min-width: 320px) and (max-width: 679px)"),
    // For 200% Zoom, the “medium” layout size applies for viewports/breakpoints for screen width of 680px to 1023px.
    isMd: (0, import_useMediaQuery.useMediaQuery)("(min-width: 680px) and (max-width: 1023px)"),
    isLg: (0, import_useMediaQuery.useMediaQuery)("(min-width: 1024px) and (max-width: 1599px)"),
    isXl: (0, import_useMediaQuery.useMediaQuery)("(min-width: 1600px)"),
    active: "xs"
  };
  if (breakpoints.isXs)
    breakpoints.active = "xs";
  if (breakpoints.isSm)
    breakpoints.active = "sm";
  if (breakpoints.isMd)
    breakpoints.active = "md";
  if (breakpoints.isLg)
    breakpoints.active = "lg";
  if (breakpoints.isXl)
    breakpoints.active = "xl";
  return breakpoints;
};
var Breakpoint = function Breakpoint2(_ref) {
  var at = _ref.at, children = _ref.children;
  if (!at) {
    console.warn("<Breakpoint>: must specify a breakpoint for the `at` prop.");
  }
  var _useBreakpoints = useBreakpoints(), active = _useBreakpoints.active;
  return active === at ? children : null;
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Breakpoint,
  useBreakpoints
});
//# sourceMappingURL=useBreakpoints.hook.js.map